/**
 * Configuración para verificaciones anti-bot
 */

export const ANTI_BOT_CONFIG = {
  // Tiempo de expiración para la interacción del usuario (en ms)
  USER_INTERACTION_TIMEOUT: 30000, // 30 segundos
  
  // Número mínimo de verificaciones que deben pasar
  MIN_VERIFICATION_CHECKS: 6,
  
  // Verificaciones disponibles
  VERIFICATIONS: {
    USER_INTERACTION: true,        // Interacción del usuario con la página
    HEADLESS_BROWSER: true,        // Detección de navegadores headless
    PLUGINS_CHECK: true,           // Verificación de plugins del navegador
    USER_AGENT_CHECK: true,        // Verificación del user agent
    COOKIES_CHECK: true,           // Verificación de cookies habilitadas
    JAVASCRIPT_CHECK: true,        // Verificación de JavaScript
    SCREEN_RESOLUTION: true,       // Verificación de resolución de pantalla
    TIMEZONE_CHECK: true,          // Verificación de timezone
  },
  
  // Mensajes de error
  MESSAGES: {
    VERIFICATION_FAILED: 'No se pudo verificar que seas humano. Por favor, inténtalo de nuevo.',
    VERIFICATION_SUCCESS: '¡Verificación exitosa! Redirigiendo a WhatsApp...',
    VERIFYING: 'Verificando...',
    CONFIRM_HUMAN: 'Por favor, confirma que eres humano para continuar',
    WHATSAPP_REDIRECT: 'Estás a punto de abrir WhatsApp para contactar a Neuro Peques',
  },
  
  // Delays (en ms)
  DELAYS: {
    VERIFICATION_PROCESS: 1000,    // Tiempo de verificación
    WHATSAPP_REDIRECT: 500,        // Delay antes de redirigir a WhatsApp
  },
  
  // Configuración de eventos para detectar interacción humana
  HUMAN_INTERACTION_EVENTS: [
    'mousedown',
    'mousemove', 
    'keypress',
    'scroll',
    'touchstart',
    'click'
  ] as const,
  
  // Configuración de navegadores sospechosos
  SUSPICIOUS_BROWSER_INDICATORS: {
    MIN_USER_AGENT_LENGTH: 10,
    MIN_PLUGINS_COUNT: 0,
    MIN_SCREEN_WIDTH: 100,
    MIN_SCREEN_HEIGHT: 100,
  },
};

// Tipos para las verificaciones
export type VerificationCheck = keyof typeof ANTI_BOT_CONFIG.VERIFICATIONS;
export type HumanInteractionEvent = typeof ANTI_BOT_CONFIG.HUMAN_INTERACTION_EVENTS[number];

// Interfaz para el resultado de verificación
export interface VerificationResult {
  isHuman: boolean;
  passedChecks: number;
  totalChecks: number;
  failedChecks: string[];
  score: number;
}

// Función para calcular el score de verificación
export function calculateVerificationScore(passedChecks: number, totalChecks: number): number {
  return Math.round((passedChecks / totalChecks) * 100);
}

// Función para obtener el estado de verificación
export function getVerificationStatus(score: number): 'excellent' | 'good' | 'fair' | 'poor' {
  if (score >= 90) return 'excellent';
  if (score >= 75) return 'good';
  if (score >= 60) return 'fair';
  return 'poor';
}
